/**
 * pdp-buy-box.js
 * Pairs with snippets/buy-buttons.liquid.
 *
 * Per the PDP requirements doc: once qty > 1, show the line total in the
 * Add to Cart button; at qty 1 the button stays plain "Add to cart" text
 * (server-rendered default, untouched here).
 *
 * Total = unit price × qty — plain arithmetic, never a discount
 * computation. The unit price itself is always a value Shopify already
 * computed server-side: either this button's own data-atc-unit-price
 * (the variant's regular price, refreshed on Dawn's own
 * PUB_SUB_EVENTS.variantChange) or, when Subscribe is selected, the
 * currently-selected plan's data-price-cents on the "Deliver every"
 * <option> that snippets/subscription-frequency.liquid + assets/
 * subscription-frequency.js already render/maintain — this file only
 * reads it, it never re-derives a subscription discount itself.
 */
(function () {
  // Compact port of Shopify's standard money.js formatter, fed by
  // shop.money_format (see the inline JSON below) rather than hardcoding
  // a currency symbol — the same value the theme already uses to render
  // every other price on the page via the `money` filter.
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';

      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initBuyBox(button) {
    var totalEl = button.querySelector('[data-atc-total-price]');
    var dividerEl = button.querySelector('[data-atc-divider]');
    if (!totalEl || !dividerEl) return;

    var scope = button.closest('.product__info-container') || document;
    var qtyInput = scope.querySelector('.quantity__input');
    var sellingPlanInput = scope.querySelector('[data-selling-plan-input]');
    var frequencySelect = scope.querySelector('[data-sf-frequency-select]');
    var sfRadios = scope.querySelectorAll('[data-sf-radio]');

    function recompute() {
      if (button.disabled) {
        totalEl.hidden = true;
        dividerEl.hidden = true;
        return;
      }

      var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
      var unitCents = parseInt(button.getAttribute('data-atc-unit-price'), 10) || 0;

      if (sellingPlanInput && !sellingPlanInput.disabled && frequencySelect) {
        var option = frequencySelect.selectedOptions[0];
        var planCents = option && parseInt(option.dataset.priceCents, 10);
        if (planCents) unitCents = planCents;
      }

      if (qty > 1) {
        totalEl.textContent = formatMoney(unitCents * qty);
        totalEl.hidden = false;
        dividerEl.hidden = false;
      } else {
        totalEl.hidden = true;
        dividerEl.hidden = true;
      }
    }

    if (qtyInput) qtyInput.addEventListener('change', recompute);
    if (frequencySelect) frequencySelect.addEventListener('change', recompute);
    sfRadios.forEach(function (radio) {
      radio.addEventListener('change', recompute);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data.variant;
        if (!variant) return;
        button.setAttribute('data-atc-unit-price', variant.price);
        recompute();
      });
    }

    recompute();
  }

  document.querySelectorAll('[data-atc-unit-price]').forEach(initBuyBox);
})();
